function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("g", null, React.createElement("g", null, React.createElement("path", {
  d: "M254.26,0C113.845,0,0,113.845,0,254.26s113.845,254.26,254.26,254.26 s254.26-113.845,254.26-254.26S394.675,0,254.26,0z M371.696,403.288c-3.178,5.816-9.122,9.058-15.287,9.058 c-2.86,0-5.721-0.667-8.422-2.129c-40.713-22.438-86.957-34.293-133.677-34.293c-28,0-55.651,4.163-82.126,12.363 c-9.217,2.86-19.006-2.288-21.835-11.537c-2.86-9.185,2.288-28.7,11.537-31.592c29.844-9.249,60.959-13.921,92.455-13.921 c52.568,0,104.66,13.349,150.522,38.616C373.317,374.461,376.4,394.866,371.696,403.288z M404.019,307.527 c-3.623,7.024-10.742,18.338-18.084,18.338c-3.21,0-6.388-0.699-9.376-2.32c-50.471-26.189-105.041-39.474-162.218-39.474 c-31.496,0-62.77,4.132-92.964,12.459c-10.901,2.956-22.089-3.401-25.045-14.302c-2.924-10.901,3.464-29.431,14.334-32.386 c33.689-9.185,68.587-13.857,103.674-13.857c62.898,0,125.445,15.256,180.938,44.114 C405.29,285.248,409.199,297.516,404.019,307.527z M417.526,230.836c-3.464,0-7.024-0.795-10.361-2.447 c-60.228-30.034-125.096-45.226-192.761-45.226c-35.279,0-70.43,4.291-104.533,12.713c-12.522,3.083-25.14-4.513-28.223-17.004 c-3.115-12.459,4.513-27.555,17.004-30.638c37.726-9.376,76.659-14.111,115.72-14.111c74.975,0,146.867,16.877,213.578,50.121 c11.537,5.753,16.241,19.737,10.488,31.242C434.308,223.653,426.108,230.836,417.526,230.836z"
}))));

var _ref3 =
/*#__PURE__*/
React.createElement("g", null);

var _ref4 =
/*#__PURE__*/
React.createElement("g", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", null);

var _ref6 =
/*#__PURE__*/
React.createElement("g", null);

var _ref7 =
/*#__PURE__*/
React.createElement("g", null);

var _ref8 =
/*#__PURE__*/
React.createElement("g", null);

var _ref9 =
/*#__PURE__*/
React.createElement("g", null);

var _ref10 =
/*#__PURE__*/
React.createElement("g", null);

var _ref11 =
/*#__PURE__*/
React.createElement("g", null);

var _ref12 =
/*#__PURE__*/
React.createElement("g", null);

var _ref13 =
/*#__PURE__*/
React.createElement("g", null);

var _ref14 =
/*#__PURE__*/
React.createElement("g", null);

var _ref15 =
/*#__PURE__*/
React.createElement("g", null);

var _ref16 =
/*#__PURE__*/
React.createElement("g", null);

var _ref17 =
/*#__PURE__*/
React.createElement("g", null);

var SvgSpotify = function SvgSpotify(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 508.52 508.52",
    style: {
      enableBackground: "new 0 0 508.52 508.52"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSpotify, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/spotify.a6b8f104.svg";
export { ForwardRef as ReactComponent };